export default {
    eqDetails_00001: 'Apply configuration',
    eqDetails_00002: 'Charger detail',
    eqDetails_00003: 'Charger info',
    eqDetails_00004: 'Charger configuration',
    eqDetails_00005: 'Charge point management',
    eqDetails_00006: 'Device maintenance',
    eqDetails_00007: 'Restart',
    eqDetails_00008: 'Device reboot command has been sent, the reboot process will take approximately 5 minutes. Please stay on this page and do not refresh the page.',
    eqDetails_00009: 'Confirm',
    eqDetails_00010: 'Start charging',
    eqDetails_00011: 'Device rebooted successfully',
    eqDetails_00012: 'Remote reboot',
    eqDetails_00013: 'Device reboot failed',
    eqDetails_00014: 'Charger name',
    eqDetails_00015: 'Station',
    eqDetails_00016: 'Check',
    eqDetails_00017: 'Serial number',
    eqDetails_00018: 'Manufacturer',
    eqDetails_00019: 'Charger model',
    eqDetails_00020: 'Please enter the name of charger',
    eqDetails_00021: 'Device enable, electromagnetic lock and other configurations will automatically push the configuration to the device after modification, you need to wait for the device response before updating the page',
    eqDetails_00022: 'Push configuration',
    eqDetails_00023: 'Push to device',
    eqDetails_00024: 'Charger  enabled',
    eqDetails_00025: 'Connector lock enabled',
    eqDetails_00026: 'Charge even if the lock is broken',
    eqDetails_00027: 'Parking area radar',
    eqDetails_00028: 'Service hours',
    eqDetails_00029: 'Start time',
    eqDetails_00030: 'Close time',
    eqDetails_00031: 'Max. charging current(A)',
    eqDetails_00032: 'Max. charging power(kW)',
    eqDetails_00033: 'Apply failed',
    eqDetails_00034: 'Device is offline',
    eqDetails_00035: 'Waiting for device response',
    eqDetails_00036: 'Apply success',
    eqDetails_00037: 'Date set incorrectly',
    eqDetails_00038: 'Power module requires maintenance timing prompt: accumulated charging hours from reset time',
    eqDetails_00039: '{hours}hours',
    eqDetails_00040: 'Reset time：',
    eqDetails_00041: 'Normal',
    eqDetails_00042: 'Fault',
    eqDetails_00043: 'Are you sure you have completed this maintenance for this charging post power module? After clicking OK, the power module requires a maintenance prompt to retime.',
    eqDetails_00044: 'Reminder',
    eqDetails_00045: 'Charge point name',
    eqDetails_00046: 'Charging QR code',
    eqDetails_00047: 'Dynamic QR code',
    eqDetails_00048: 'Fixed QR Code',
    eqDetails_00049: 'Upgrade to fixed QR code',
    eqDetails_00050: 'Custom QR Code',
    eqDetails_00051: 'Remote control',
    eqDetails_00052: 'Restart charging point',
    eqDetails_00053: 'End charging',
    eqDetails_00054: 'Reset to Available',
    eqDetails_00055: 'Charging point status',
    eqDetails_00056: 'Car parking management device',
    eqDetails_00057: 'N/A',
    eqDetails_00058: 'Stake-controlled parking space lock',
    eqDetails_00059: 'Cloud-controlled parking space lock',
    eqDetails_00060: 'Parking space management device information',
    eqDetails_00061: 'Please enter device code',
    eqDetails_00062: 'Enable parking space management device',
    eqDetails_00063: 'Remote control of the parking space management device',
    eqDetails_00064: 'Rise',
    eqDetails_00065: 'Descending',
    eqDetails_00066: 'Current parking space occupancy billing user',
    eqDetails_00067: 'Occupancy start time',
    eqDetails_00068: 'User details',
    eqDetails_00069: 'Manual end of this occupancy charge billing',
    eqDetails_00070: 'QR code of parking space management device lowering ',
    eqDetails_00071: 'Generate fixed QR code',
    eqDetails_00072: 'Occupancy in progress',
    eqDetails_00073: 'Not enabled',
    eqDetails_00074: 'Offline',
    eqDetails_00075: 'Fault',
    eqDetails_00076: 'Appointment in progress',
    eqDetails_00077: 'Available',
    eqDetails_00078: 'Connected',
    eqDetails_00079: 'Charging',
    eqDetails_00080: 'Pending car move',
    eqDetails_00081: 'Pending plug out',
    eqDetails_00082: 'Connector',
    eqDetails_00083: 'Start charging',
    eqDetails_00084: 'Please save the previous operation！！',
    eqDetails_00085: 'Current space has users who are being billed for space occupancy, please modify later!',
    eqDetails_00086: 'Parameter is empty',
    eqDetails_00087: 'Maximum 20 characters',
    eqDetails_00088: 'Start charging command has been sent',
    eqDetails_00089: 'End charging command sent',
    eqDetails_00090: 'Sent successfully',
    eqDetails_00091: 'Upgrade to fixed QR code',
    eqDetails_00092: 'Generated QR code successfully',
    eqDetails_00093: 'Enabled',
    eqDetails_00094: 'Not enabled',
    eqDetails_00095: 'Cloud-controlled parking space lock',
    eqDetails_00096: 'Stake-controlled parking space lock',
    eqDetails_00097: 'Please enter the content of the QR code, the QR code you have configured will be displayed on the pile',
    eqDetails_00098: 'Note: Only fixed QR codes can be generated and cannot be restored to their original state',
    eqDetails_00099: 'The custom QR code cannot be empty!',
    eqDetails_00100: 'Custom QR code is empty ',
    eqDetails_00101: 'Configuration failed',
    eqDetails_00102: 'The length cannot exceed {0} characters',
    eqDetails_00103: 'Current charging duration (minutes)',
    eqDetails_00104: 'Current pre-charged idle fee ($)',
    eqDetails_00105: 'Revised Idle fee ($)',
    eqDetails_00106: 'Please enter the amount',
    eqDetails_00107: 'Please enter the revised idle fee',
    eqDetails_00108: 'Please enter the correct number',
    eqDetails_00109: 'Manual end of billing for this occupancy charge was successful',
    eqDetails_00110: 'The maximum number of fixed QR codes is 100,000 and is not recallable, please proceed with caution, sure to upgrade?',
    eqDetails_00111: 'Upgrade successful',
    eqDetails_00112: 'Done',
    eqDetails_00113: 'Did you generate a fixed QR code for the car parking management device drop?',
    eqDetails_00114: 'No QR code at this time',
    eqDetails_00115: 'If the device is offline, only users in the whitelist are supported to start charging',
    eqDetails_00116: 'Clear whitelist',
    eqDetails_00117: 'Apply whitelist',
    eqDetails_00118: 'Charger ID',
    eqDetails_00119: '',
    eqDetails_10000: 'Are you sure you have completed this maintenance for all {0} charging points? After clicking OK, all {0} service required reminders are re-timed. ',
    eqDetails_10001: 'Modify all valves',
    eqDetails_10002: 'hour',
    eqDetails_10003: 'time',
    eqDetails_10004: 'Tips',
    eqDetails_10005: 'Apply to all',
    eqDetails_10006: 'Reset all',
    eqDetails_10007: 'Service time',
    eqDetails_10008: 'Used',
    eqDetails_10009: 'Maintenance timing prompt threshold:',
    eqDetails_10010: 'The cumulative usage time since the reset time is greater than or equal to',
    eqDetails_10011: 'Please complete',
    eqDetails_10012: 'Power Module',
    eqDetails_10013: 'Storage battery',
    eqDetails_10014: 'Fan',
    eqDetails_10015: 'Connector',
    eqDetails_10016: 'Lance tip relay (DC+)',
    eqDetails_10017: 'Wire Puller',
    eqDetails_10018: 'Surge Protector',
    eqDetails_10019: 'LCD screen',
    eqDetails_10020: 'Bleed Resistor',
    eqDetails_10021: 'Force charge',
    eqDetails_10022: 'Force discharge',
    eqDetails_10023: 'Disabled',
    eqDetails_10024: 'Reset',
    eqDetails_10025: 'Charger Info',
    eqDetails_10026: 'Charger settings',
    eqDetails_10027: 'About the settings',
    eqDetails_10028: 'Connectors',
    eqDetails_10029: 'Enabled',
    eqDetails_10030: 'Connector name',
    eqDetails_10031: 'Battery-charge mode',
    eqDetails_10032: 'Air conditioner operation mode',
    eqDetails_10033: 'Operating mode settings',
    eqDetails_10034: 'NZ Batterys',
    eqDetails_10035: 'Battery',
    eqDetails_10036: 'Battery cabinet name',
    eqDetails_10037: 'Battery cabinet capacity(kWh)',
    eqDetails_10038: 'Battery cycle time(times)',
    eqDetails_10039: 'Battery cabinet SOC(%)',
    eqDetails_10040: 'Battery cabinet SOH(%)',
    eqDetails_10041: 'Reboot',
    eqDetails_10042: 'Send whitelist',
    eqDetails_10043: 'Error logs',
    eqDetails_10044: 'Setting description',
    eqDetails_10045: 'Charger swtich, electromagnetic lock and other settings will automatically apply the setting to the charger after modification, you need to wait for the charger response before updating the page',
    eqDetails_10046: 'If the charger is offline, only users in the whitelist are supported to start charging',
    eqDetails_10047: 'Learn more',
    eqDetails_10047: 'more',
    eqDetails_10048: 'Charging SOC Limit',
    eqDetails_10049: 'Discharging SOC Limit',
    eqDetails_10050: "Stored Power Chargin' Limit(kW)",
    eqDetails_10051: 'Energy storage discharge power limit（kW）',
    eqDetails_10052: 'AC Discharge Power（kW）',
    eqDetails_10053: 'Are you sure to restart the device?',
    eqDetails_10054: 'Range',
    eqDetails_10055: "Fault",
    eqDetails_10056: "No limit {0}%",
    eqDetails_10057: "Restart Battery",
    eqDetails_10058: "limit{0}%",
    eqDetails_10059: "The command has been sent successfully, the device will be executed after charging, please refresh the page later to view the execution result",
    eqDetails_10060: "Charged",
    eqDetails_10061: "The push is successful, waiting for the device to respond",
    eqDetails_10062: "The working status of the battery cabinet has been switched successfully",
    eqDetails_10063: "Failed to switch the working state of the battery cabinet",
    eqDetails_10064: "Battery cabinet working state switching overtime",
    eqDetails_10065: "The connector is charging, no need to start charging again",
    eqDetails_10066: "Please disable the parking space management device first",
    eqDetails_10067: "Set to Idle",
    eqDetails_10068: "This function is only used for emergency processing when the platform and muzzle information are out of sync. Are you sure to set it to idle?",
    eqDetails_10069: "Unlimited, Rated maximum charging power is {0} kW",
    eqDetails_10070: "Unlimited, Rated maximum current is {0} A",
    eqDetails_10071: "The rated maximum charging power is not set in the system for this device model and cannot be modified temporarily. Please contact the administrator.",
    eqDetails_10072: "The rated maximum current is not set in the system for this device model and cannot be modified temporarily. Please contact the administrator.",
    eqDetails_10073: "Please enter the correct range",
    eqDetails_10074: "Charging port ID:",

    detailDepot_00182: "Site support white list",
    detailDepot_00545: "Please save the previous operation!",
    detailDepot_00112: "Can be charged",
    detailDepot_00106: "Charging is not allowed",
    detailDepot_00107: "Forced grid connection",
    detailDepot_00108: 'Grid connection power limit(kW)',
    detailDepot_00111: 'Dual Platform',

    //维保类型（英语）
    eqDetails_21000:"DC meter",
    eqDetails_21001:"AC meter",
    eqDetails_21002:"Switching relay",
    eqDetails_21003:"Access control sensor",
    eqDetails_21004:"Tip sensor",
    eqDetails_21005:"Smoke sensor",
    eqDetails_21006:"Liquid level sensor",
    eqDetails_21007:"Liquid cooling pump",
    eqDetails_21008:"Liquid cooling pump fan",
    eqDetails_21009:"Light bar",
    eqDetails_21010:"Filter",
    eqDetails_21011:"Energy storage battery health",
    eqDetails_21012:"AC contactor",
    eqDetails_21013:"Lance tip relay (DC-)",
    eqDetails_21014:"Manufacturer",
    eqDetails_21015:"UUGreenPower",
    eqDetails_21016:"INFY Power",
    eqDetails_21017:"Megmeet",
    eqDetails_21018:"Lance tip relay (DC+)",
    eqDetails_21019:"Battery cabinet tilt",
    eqDetails_21020:"Tilt Correction",

    detailDepot_10112: "Refers to the maximum operating power of the ACDC module, which cannot be exceeded whether it is used to charge the NZS battery or the vehicle.",
    eqDetails_10075: 'Retrieve & edit SN file',
    eqDetails_10076: 'Retrieve charger files',
    eqDetails_10077: 'Retrieve charger logs',
    eqDetails_10078: 'Log types',
    eqDetails_10079: 'All types',
    eqDetails_10080: 'APP Log',
    eqDetails_10081: 'DCB Log',
    eqDetails_10082: 'Logcat',
    eqDetails_10083: 'SystemLog',
    eqDetails_10084: 'Log date',
    eqDetails_10085: 'File types',
    eqDetails_10086: 'SP file',
    eqDetails_10087: 'SN file',
    eqDetails_10088: 'Charger end database',
    eqDetails_10089: 'APN file',
    eqDetails_10090: 'The date range cannot exceed 30 days, please reselect!',
    eqDetails_10091: 'Please select a date',
    eqDetails_10092: 'Edit SN file',
    eqDetails_10093: 'The task is currently executing. Please go to the asynchronous task page to obtain and view the logs.',
    eqDetails_10094: 'Retrieve & edit APN file',
    eqDetails_10095: 'Edit APN file',
    eqDetails_10096: 'Obtain file failed',
    eqDetails_10097: 'Only the obtained fields can be edited and cannot be deleted.',
    eqDetails_10098: 'Please fill in the form correctly',
    eqDetails_10099: 'Save failed because {0} field is missing',
    eqDetails_21021:"SOH Is lower than",
    eqDetails_21022:"Current",
}